export enum UserPermissionsType {
  COMMENTS_MARK_VIEWED = 'COMMENTS_MARK_VIEWED',
  COMMENTS_TRANSFER = 'COMMENTS_TRANSFER',
  COMMENTS_HIDDEN = 'COMMENTS_HIDDEN',
  COMMENTS_REPLY = 'COMMENTS_REPLY',
  COMMENTS_EDIT = 'COMMENTS_EDIT',
  COMMENTS_HIDE = 'COMMENTS_HIDE',
  COMMENTS_DELETE = 'COMMENTS_DELETE',
  COMMENTS_ADD_LINK = 'COMMENTS_ADD_LINK',
  AVATARS_SELECT_ALL_ICONS = 'AVATARS_SELECT_ALL_ICONS',
  UNLOCK_ALL_COURSE_CLASS = 'UNLOCK_ALL_COURSE_CLASS',
  BACKOFFICE_ACCESS = 'BACKOFFICE_ACCESS',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  IMPUGMENTS_MANAGEMENT = 'IMPUGMENTS_MANAGEMENT',
  TEST_MANAGEMENT = 'TEST_MANAGEMENT',
  PSYCHOS_MANAGEMENT = 'PSYCHOS_MANAGEMENT',
  CASE_STUDY_MANAGEMENT = 'CASE_STUDY_MANAGEMENT',
  SIMULACRUM_MANAGEMENT = 'SIMULACRUM_MANAGEMENT',
  EXAM_MANAGEMENT = 'EXAM_MANAGEMENT',
  EXAM_ANNOUNCEMENT_ACCESS = 'EXAM_ANNOUNCEMENT_ACCESS',
  COURSE_CLASS_MANAGEMENT = 'COURSE_CLASS_MANAGEMENT',
  VIEW_ALL_PLATFORMS_AND_OPOSITIONS = 'VIEW_ALL_PLATFORMS_AND_OPOSITIONS',
  IS_ELITE_USER = 'IS_ELITE_USER',
  NOTIFICATIONS_ACCESS = 'NOTIFICATIONS_ACCESS',
  NOTIFICATIONS_OPTIONS_IN_APP = 'NOTIFICATIONS_OPTIONS_IN_APP',
  NOTIFICATIONS_OPTIONS_MODAL = 'NOTIFICATIONS_OPTIONS_MODAL',
  NOTIFICATIONS_OPTIONS_TOPBAR = 'NOTIFICATIONS_OPTIONS_TOPBAR',
  NOTIFICATIONS_OPTIONS_EMAIL = 'NOTIFICATIONS_OPTIONS_EMAIL',
  NOTIFICATIONS_OPTIONS_PUSH = 'NOTIFICATIONS_OPTIONS_PUSH',
  SHOW_ALL_RANKING = 'SHOW_ALL_RANKING',
  CHECK_USERS_ON_DB = 'CHECK_USERS_ON_DB',
  UPSERT_PROMOTIONS = 'UPSERT_PROMOTIONS',
  SETTINGS_NINJA = 'SETTINGS_NINJA',
  SETTINGS_ACADEMY = 'SETTINGS_ACADEMY',
  COMMENTS_OWN_ONLY = 'COMMENTS_OWN_ONLY',
  ROLES_MANAGEMENT = 'ROLES_MANAGEMENT',
  ACCOUNT_RISK_ACCESS = 'ACCOUNT_RISK_ACCESS',
  ACCOUNT_RISK_MANAGEMENT = 'ACCOUNT_RISK_MANAGEMENT',
  SURVEYS_MANAGEMENT = 'SURVEYS_MANAGEMENT',
  BILLING_MANAGEMENT = 'BILLING_MANAGEMENT',
  // Crear academias y productos (alta de catálogo). Solo MANAGER (no CONTABILIDAD).
  ACADEMY_MANAGEMENT = 'ACADEMY_MANAGEMENT',
  // VER el apartado de academias y oposiciones: bloque del sidebar (selector de
  // oposición, estadísticas, crear oposición), ruta `/academia` y la sección de
  // academias de la paleta ⌘K. Es solo visibilidad/lectura: no da el alta de
  // catálogo (eso es ACADEMY_MANAGEMENT) ni la gestión de exámenes y el comando
  // `exams.list` (eso es EXAM_MANAGEMENT, que además tienen MANAGER_TEST y
  // USUARIO_NORMAL y por eso no servía para gatear este apartado).
  ACADEMIES_ACCESS = 'ACADEMIES_ACCESS',
  AB_TEST_MANAGEMENT = 'AB_TEST_MANAGEMENT',
  CLI_ACCESS = 'CLI_ACCESS',
  CLI_ADMIN = 'CLI_ADMIN',
  HUBSPOT_READ_ACCESS = 'HUBSPOT_READ_ACCESS',
  IMPERSONATE_USERS = 'IMPERSONATE_USERS',
  KNOWLEDGE_READ_ACCESS = 'KNOWLEDGE_READ_ACCESS',
  KNOWLEDGE_SYNC_ADMIN = 'KNOWLEDGE_SYNC_ADMIN',
  // Acceso a las colas del bot de IA (una por vista). Las tiene el rol MANAGER.
  BOT_DRAFTS_ACCESS = 'BOT_DRAFTS_ACCESS',
  BOT_PROPOSALS_ACCESS = 'BOT_PROPOSALS_ACCESS',
  // Agentes de ventas (chatbot de la web pública, comandos `bots.*`).
  // Las filas de permissions_on_roles las crea la migración
  // 20260817120000_add_sales_chat_bots: VIEW/EDIT para SALES, MARKETING y
  // MANAGER; PUBLISH solo para MANAGER.
  SALES_BOT_VIEW = 'SALES_BOT_VIEW',
  SALES_BOT_EDIT = 'SALES_BOT_EDIT',
  SALES_BOT_PUBLISH = 'SALES_BOT_PUBLISH',
  /**
   * Registro de actividad del backoffice (`/actividad`).
   *
   * Antes colgaba de `BACKOFFICE_ACCESS`, que es OBLIGATORIO para todo rol de
   * categoría `employee` (ver `MANDATORY_EMPLOYEE_PERMISSIONS` y el guard de
   * `api/roles/[role]`). Por construcción, entonces, TODO empleado veía el log
   * global del backoffice: de ahí el reporte de profesores entrando en
   * «Actividad». Separarlo en su propio permiso es lo que permite quitárselo.
   *
   * La migración `20260910120000_activity_access` lo concede SOLO a MANAGER;
   * cualquier otro rol que lo necesite se lo da un administrador desde /roles.
   */
  ACTIVITY_ACCESS = 'ACTIVITY_ACCESS',
  // Biblioteca Ninja (#2942). La migración 20261020120000_library_access los
  // concede a MANAGER; el resto de roles, desde /roles.
  /** Ver dashboard e historial de accesos. */
  LIBRARY_ACCESS = 'LIBRARY_ACCESS',
  /** Check-in manual, escáner y revisión de eventos. */
  LIBRARY_CHECKIN = 'LIBRARY_CHECKIN',
  /** Bloquear/desbloquear el acceso de un alumno. */
  LIBRARY_MANAGEMENT = 'LIBRARY_MANAGEMENT',
  /**
   * Tarjeta Ninja en beta: la ve aunque la sede no la haya abierto a todos
   * (`library_site.card_public`). Lo concede 20261021120000_library_card_beta
   * a MANAGER y al rol BIBLIOTECA_EQUIPO.
   */
  LIBRARY_CARD = 'LIBRARY_CARD',
}

export enum UserRolesType {
  MANAGER = 'MANAGER',
  MANAGER_TEST = 'MANAGER_TEST',
  MANAGER_MANUALES = 'MANAGER_MANUALES',
  MANAGER_COMENTARIOS = 'MANAGER_COMENTARIOS',
  REDACTOR_TEST = 'REDACTOR_TEST',
  ATENCION_ALUMNO = 'ATENCION_ALUMNO',
  PROFESSOR = 'PROFESSOR',
  EDITOR = 'EDITOR',
  OFFICE = 'OFFICE',
  SUPPORT = 'SUPPORT',
  ELITE = 'ELITE',
  TEST_WRITER = 'TEST_WRITER',
  PSICO_WRITER = 'PSICO_WRITER',
  FREEMIUM = 'FREEMIUM',
}

export const EMPLOYEE_ROLES: UserRolesType[] = [
  UserRolesType.MANAGER,
  UserRolesType.MANAGER_TEST,
  UserRolesType.MANAGER_MANUALES,
  UserRolesType.MANAGER_COMENTARIOS,
  UserRolesType.REDACTOR_TEST,
  UserRolesType.ATENCION_ALUMNO,
  UserRolesType.PROFESSOR,
]

export const STUDENT_ROLES: UserRolesType[] = [
  UserRolesType.ELITE,
  UserRolesType.FREEMIUM,
]

/**
 * CLI roles and CLI permissions are intentionally NOT manageable from the
 * admin UI/API. They control who can run privileged backoffice automation
 * (read/write commands, impersonation, etc.) and a misconfiguration would
 * silently grant cross-account access to whoever toggles a checkbox.
 *
 * To assign or revoke them, run a migration or a direct SQL statement.
 * The admin endpoints in `apps/admin/src/pages/api/roles/*` enforce these
 * predicates and the matching UI hides them from view.
 */
export function isCliProtectedRole(role: string): boolean {
  return role.startsWith('CLI_')
}

export function isCliProtectedPermission(permission: string): boolean {
  // 'IMPERSONATE_USERS' is referenced as a literal so this helper is safe
  // to ship independently of the PR that introduces the enum entry.
  return permission.startsWith('CLI_') || permission === 'IMPERSONATE_USERS'
}

/**
 * Cuentas que pueden VER (nunca editar) los roles CLI en la pestaña de Roles
 * del admin. Es una lista de solo-lectura para inspección: sirve para que los
 * responsables comprueben qué concede cada rol CLI sin abrir la base de datos.
 *
 * ⚠ Deliberadamente NO es un permiso de escritura. El gate de mutación sigue
 * siendo SQL-only (ver `isCliProtectedRole`/`isCliProtectedPermission` arriba y
 * los 403 de `apps/admin/src/pages/api/roles/*`): `CLI_OPERATOR` concede
 * `IMPERSONATE_USERS`, así que un allowlist con permiso de edición convertiría
 * el control SQL-only en una vía de auto-concesión.
 *
 * ⚠ El email NO es una frontera de identidad en este esquema: cualquiera con
 * `USER_MANAGEMENT` puede reescribir el email de otra cuenta
 * (`api/account/update.ts` → `changeUserEmail`). Por eso este allowlist solo
 * puede gobernar VISIBILIDAD. No lo reutilices para autorizar escrituras.
 */
export const CLI_ROLES_VIEWER_EMAILS: readonly string[] = [
  'edu@formacion.ninja',
  'eloi@formacion.ninja',
]

export function canViewCliRoles(email?: string | null): boolean {
  if (!email) return false
  return CLI_ROLES_VIEWER_EMAILS.includes(email.trim().toLowerCase())
}

/**
 * Origen de un token de acceso al backoffice, embebido como claim `src` en el
 * JWE que emite cada canal. Determina la política de autorización de los
 * backoffice commands:
 *  - 'web'   → admin web: BACKOFFICE_ACCESS + permiso de dominio del comando
 *              (como el admin/GraphQL viejo), SIN exigir CLI_ACCESS/CLI_ADMIN.
 *  - 'cli'   → CLI `ninja`: gate CLI (BACKOFFICE_ACCESS + CLI_ACCESS; writes CLI_ADMIN).
 *  - 'agent' → agente Claude (AGENT_BOT): mismo gate CLI que 'cli'.
 */
export type BackofficeTokenOrigin = 'web' | 'cli' | 'agent'

/**
 * Normaliza el claim `src` a un origen conocido. FAIL-CLOSED: cualquier valor
 * ausente/desconocido se degrada a 'cli' (el tier con gate CLI, más restrictivo
 * para el admin web) para no abrir el camino web por accidente ni regresionar
 * tokens legacy emitidos sin `src`.
 */
export function toBackofficeOrigin(value: unknown): BackofficeTokenOrigin {
  return value === 'web' || value === 'cli' || value === 'agent'
    ? value
    : 'cli'
}

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  [UserRolesType.MANAGER]: 'Manager',
  [UserRolesType.MANAGER_TEST]: 'Manager test',
  [UserRolesType.MANAGER_MANUALES]: 'Manager manuales',
  [UserRolesType.MANAGER_COMENTARIOS]: 'Manager comentarios',
  [UserRolesType.REDACTOR_TEST]: 'Redactor test',
  [UserRolesType.ATENCION_ALUMNO]: 'Atención alumno',
  [UserRolesType.PROFESSOR]: 'Profesor',
  [UserRolesType.ELITE]: 'Elite',
  [UserRolesType.FREEMIUM]: 'Freemium',
  // Roles CLI: no están en `UserRolesType` (se crean por migración, ver
  // 20260514120000 y 20260521120000) pero necesitan nombre legible para las
  // pantallas que los muestran en solo lectura.
  CLI_READER: 'CLI (read-only)',
  CLI_OPERATOR: 'CLI (operator)',
}
